import { AxiosInstance } from 'axios';
import { BaseHttpClientOptionsParams, Endpoint, RequestConfig } from './types';

export class BaseHttpClient {
  protected axiosInstance: AxiosInstance;
  protected defaultExtractNestedData: boolean;
  protected static instance: BaseHttpClient;

  constructor(
    axiosInstance: AxiosInstance,
    options: BaseHttpClientOptionsParams = {},
  ) {
    const { defaultExtractNestedData = false } = options;

    this.axiosInstance = axiosInstance;
    this.defaultExtractNestedData = defaultExtractNestedData;
  }

  protected static getInstance(): BaseHttpClient {
    return this.instance;
  }

  static async get<T>(
    endpoint: Endpoint,
    config: RequestConfig = {},
  ): Promise<T> {
    const instance = this.getInstance();

    try {
      const { extractNestedData = instance.defaultExtractNestedData } = config;

      const response = await instance.axiosInstance.get(endpoint, config);

      if (extractNestedData) {
        return response?.data?.data;
      }

      return response?.data;
    } catch (error) {
      throw error;
    }
  }

  static async post<T>(
    endpoint: Endpoint,
    data: any,
    config: RequestConfig = {},
  ): Promise<T> {
    const instance = this.getInstance();

    try {
      const { extractNestedData = instance.defaultExtractNestedData } = config;

      const response = await instance.axiosInstance.post(
        endpoint,
        data,
        config,
      );

      if (extractNestedData) {
        return response?.data?.data;
      }

      return response?.data;
    } catch (error) {
      throw error;
    }
  }

  static async patch<T>(
    endpoint: Endpoint,
    data: any,
    config: RequestConfig = {},
  ): Promise<T> {
    const instance = this.getInstance();

    try {
      const { extractNestedData = instance.defaultExtractNestedData } = config;

      const response = await instance.axiosInstance.patch(
        endpoint,
        data,
        config,
      );

      if (extractNestedData) {
        return response?.data?.data;
      }

      return response?.data;
    } catch (error) {
      throw error;
    }
  }

  static async put<T>(
    endpoint: Endpoint,
    data: any,
    config: RequestConfig = {},
  ): Promise<T> {
    const instance = this.getInstance();

    try {
      const { extractNestedData = instance.defaultExtractNestedData } = config;

      const response = await instance.axiosInstance.put(endpoint, data, config);

      if (extractNestedData) {
        return response?.data?.data;
      }

      return response?.data;
    } catch (error) {
      throw error;
    }
  }

  static async delete<T>(
    endpoint: Endpoint,
    config: RequestConfig = {},
  ): Promise<T> {
    const instance = this.getInstance();

    try {
      const { extractNestedData = instance.defaultExtractNestedData } = config;

      const response = await instance.axiosInstance.delete(endpoint, config);

      if (extractNestedData) {
        return response?.data?.data;
      }

      return response?.data;
    } catch (error) {
      throw error;
    }
  }
}
